import React from 'react'

const MandatesIcon = ({ color = '#999FAC' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2C5.45 2 4.97933 2.196 4.588 2.588C4.196 2.97933 4 3.45 4 4V16C4 16.55 4.196 17.021 4.588 17.413C4.97933 17.8043 5.45 18 6 18H14C14.55 18 15.021 17.8043 15.413 17.413C15.8043 17.021 16 16.55 16 16V4C16 3.45 15.8043 2.97933 15.413 2.588C15.021 2.196 14.55 2 14 2H6ZM7 6H13C13.2833 6 13.5207 6.096 13.712 6.288C13.904 6.47933 14 6.71667 14 7C14 7.28333 13.904 7.521 13.712 7.713C13.5207 7.90433 13.2833 8 13 8H7C6.71667 8 6.47933 7.90433 6.288 7.713C6.096 7.521 6 7.28333 6 7C6 6.71667 6.096 6.47933 6.288 6.288C6.47933 6.096 6.71667 6 7 6ZM7 9H13C13.2833 9 13.5207 9.096 13.712 9.288C13.904 9.47933 14 9.71667 14 10C14 10.2833 13.904 10.521 13.712 10.713C13.5207 10.9043 13.2833 11 13 11H7C6.71667 11 6.47933 10.9043 6.288 10.713C6.096 10.521 6 10.2833 6 10C6 9.71667 6.096 9.47933 6.288 9.288C6.47933 9.096 6.71667 9 7 9ZM7 12H10C10.2833 12 10.5207 12.096 10.712 12.288C10.904 12.4793 11 12.7167 11 13C11 13.2833 10.904 13.5207 10.712 13.712C10.5207 13.904 10.2833 14 10 14H7C6.71667 14 6.47933 13.904 6.288 13.712C6.096 13.5207 6 13.2833 6 13C6 12.7167 6.096 12.4793 6.288 12.288C6.47933 12.096 6.71667 12 7 12Z"
      fill={color}
    />
  </svg>
)

export default MandatesIcon
